import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class GuidedWorkflowsMenuModule {
}
GuidedWorkflowsMenuModule.ɵfac = function GuidedWorkflowsMenuModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GuidedWorkflowsMenuModule)(); };
GuidedWorkflowsMenuModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: GuidedWorkflowsMenuModule });
GuidedWorkflowsMenuModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, FormsModule, IconModule, TooltipModule] });
